<template>
  <div id="administrador">
    <!-- <div class="separador text-center mt-5 py-5" data-aos="fade-up" data-aos-delay="600">
      <p class="otrafont fXG electrico">Cuestionarios Registrados</p>
    </div> -->

    <HeaderAdmin></HeaderAdmin>

    <div class="pt4">
      <!-- <div class="row pb-5">
        <div class="col-12 otrafont fpR electrico">Semana 1</div>
      </div>-->

      <!-- <b-sidebar id="sidebar-1" title="Menú" shadow>
        <div class="px-3 py-2">
          <a class="float-right fpR pointer" @click="logout"> Cerrar Sesión </a>
        </div>
      </b-sidebar> -->

      <div class="row m-0">
        <div class="col-3">
          <div class="row">
            <div class="col-12">
              <SidebarAdmin></SidebarAdmin>
            </div>
          </div>
        </div>

        <div class="col-9 bgazuladmin bgazulgradiente p-5">
          <div class="row">
            <div class="col-12">
              <b-tabs content-class="mt-3 row w-100">
                <b-tab title="Nivel 2 vs. 3" class="w-100" active lazy>
                  <div class="bg-white w-100">
                    <div class="col-12 pt-5 pb-3">
                      <div class="row px-5 pb-4">
                        <div class="col-12 pb-4">
                          <span class="bold fpG">CAMPOS DEL CONOCIMIENTO</span>
                          <p class="fpR">
                            Ayuda a identificar cuál estilo de aprendizaje
                            predomina en los estudiantes.
                          </p>
                        </div>
                        <div class="col-lg-4">
                          <p class="fpR electrico bold">
                            Filtros ({{ misiones_calculadas_3.length }}
                            resultados)
                          </p>

                          <div class="row">
                            <div class="col-12 pb-3">
                              <div class="fpG">Fortaleza</div>
                              <select
                                class="fpXG form-control"
                                v-model="filtros3.fortaleza"
                                @change="calculaNivel23()"
                              >
                                <option value="">Elige una fortaleza</option>
                                <option
                                  :value="key"
                                  v-for="(value, key) in estilos_de_pensamiento"
                                  :key="key"
                                >
                                  {{ value.nombre }}
                                </option>
                              </select>
                            </div>

                           
                          </div>

                          

                        </div>
                        <div class="col-lg-8">
                          <GChart
                            type="PieChart"
                            class="piechart"
                            :data="chartData3"
                            :options="chartOptions3"
                          ></GChart>
                        </div>
                      </div>
                      <div class="row px-5 pb-4">
                        <div class="col-lg-4">
                          <p class="fpR electrico bold">
                            Filtros ({{ misiones_calculadas_3.length }}
                            resultados)
                          </p>

                          <div class="row">
                            <div class="col-12 pb-3">
                              <div class="fpG">Perfil de Competencias</div>
                              <select
                                class="fpXG form-control"
                                v-model="filtros3.perfil"
                                @change="calculaNivel232()"
                              >
                                <option value="">Elige un perfil</option>
                                <option
                                  :value="perfil.id"
                                  v-for="perfil in perfil_de_competencias"
                                  :key="perfil.id"
                                >
                                  {{ perfil.nombre.toUpperCase() }}
                                </option>
                              </select>
                            </div>

                           
                          </div>

                          

                        </div>
                        <div class="col-lg-8">
                          <GChart
                            type="PieChart"
                            class="piechart"
                            :data="chartData3_1"
                            :options="chartOptions3"
                          ></GChart>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>


                <b-tab title="Nivel 2 vs. 4/5" class="w-100" lazy>
                  <div class="bg-white w-100">
                    <div class="col-12 pt-5 pb-3">
                      <div class="row px-5 pb-4">
                        <div class="col-12 pb-4">
                          <span class="bold fpG">OBJETIVOS DE DESARROLLO SOSTENIBLE</span>
                          <!-- <p class="fpR">
                            Ayuda a identificar cuál estilo de aprendizaje
                            predomina en los estudiantes.
                          </p> -->
                        </div>
                        <div class="col-lg-4">
                          <p class="fpR electrico bold">
                            Filtros ({{ misiones_calculadas_4.length }}
                            resultados)
                          </p>

                          <div class="row">
                            <div class="col-12 pb-3">
                              <div class="fpG">Fortaleza</div>
                              <select
                                class="fpXG form-control"
                                v-model="filtros4.fortaleza"
                                @change="calculaNivel4()"
                              >
                                <option value="">Elige una fortaleza</option>
                                <option
                                  :value="key"
                                  v-for="(value, key) in estilos_de_pensamiento"
                                  :key="key"
                                >
                                  {{ value.nombre }}
                                </option>
                              </select>
                            </div>

                           
                          </div>

                          

                        </div>
                        <div class="col-lg-8">
                          <GChart
                            type="PieChart"
                            class="piechart"
                            :data="chartData4"
                            :options="chartOptions4"
                          ></GChart>
                        </div>
                      </div>


                      <div class="row px-5 pb-4">
                        <div class="col-lg-4">
                          <p class="fpR electrico bold">
                            Filtros ({{ misiones_calculadas_4.length }}
                            resultados)
                          </p>

                          <div class="row">
                            <div class="col-12 pb-3">
                              <div class="fpG">Perfil de Competencias</div>
                              <select
                                class="fpXG form-control"
                                v-model="filtros4.perfil"
                                @change="calculaNivel41()"
                              >
                                <option value="">Elige un perfil</option>
                                <option
                                  :value="perfil.id"
                                  v-for="perfil in perfil_de_competencias"
                                  :key="perfil.id"
                                >
                                  {{ perfil.nombre.toUpperCase() }}
                                </option>
                              </select>
                            </div>

                           
                          </div>

                          

                        </div>
                        <div class="col-lg-8">
                          <GChart
                            type="PieChart"
                            class="piechart"
                            :data="chartData4_1"
                            :options="chartOptions4_1"
                          ></GChart>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>


                <b-tab title="Top de carreras" class="w-100" lazy>
                  <div class="bg-white w-100">
                    <div class="col-12 pt-5 pb-3">
                      <div class="row px-5 pb-4">
                        <div class="col-12 pb-4">
                          <span class="bold fpG">Top de carreras</span>
                          <!-- <p class="fpR">
                            Ayuda a identificar cuál estilo de aprendizaje
                            predomina en los estudiantes.
                          </p> -->
                        </div>
                        <div class="col-lg-4">
                          <p class="fpR electrico bold">
                            Filtros ({{ misiones_calculadas_5.length }}
                            resultados)
                          </p>

                          <div class="row">
                            <div class="col-12 pb-3">
                              <div class="fpG">Fortaleza</div>
                              <select
                                class="fpXG form-control"
                                v-model="filtros5.fortaleza"
                                @change="calculaNivel5()"
                              >
                                <option value="">Elige una fortaleza</option>
                                <option
                                  :value="key"
                                  v-for="(value, key) in estilos_de_pensamiento"
                                  :key="key"
                                >
                                  {{ value.nombre }}
                                </option>
                              </select>
                            </div>

                           
                          </div>

                          

                        </div>
                        <div class="col-lg-8">
                          <GChart
                            type="PieChart"
                            class="piechart"
                            :data="chartDataVias"
                            :options="chartOptionsVias"
                          ></GChart>
                        </div>
                      </div>


                      <div class="row px-5 pb-4">
                        <div class="col-lg-4">
                          <p class="fpR electrico bold">
                            Filtros ({{ misiones_calculadas_5_1.length }}
                            resultados)
                          </p>

                          <div class="row">
                            <div class="col-12 pb-3">
                              <div class="fpG">Perfil de Competencias</div>
                              <select
                                class="fpXG form-control"
                                v-model="filtros5.perfil"
                                @change="calculaNivel51()"
                              >
                                <option value="">Elige un perfil</option>
                                <option
                                  :value="perfil.id"
                                  v-for="perfil in perfil_de_competencias"
                                  :key="perfil.id"
                                >
                                  {{ perfil.nombre.toUpperCase() }}
                                </option>
                              </select>
                            </div>

                           
                          </div>

                          

                        </div>
                        <div class="col-lg-8">
                          <GChart
                            type="PieChart"
                            class="piechart"
                            :data="chartDataVias_1"
                            :options="chartOptionsVias_1"
                          ></GChart>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-tab>

                
              

              </b-tabs>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Glyphicons></Glyphicons>
  </div>
</template>


<script>
import { mapState } from "vuex";
import Glyphicons from "@/views/Glyphicons";
import AOS from "aos";
import swal from "sweetalert2";

import SidebarAdmin from "@/components/SidebarAdmin";
import HeaderAdmin from "@/components/HeaderAdmin";

import * as fb from "../../firebase";
import * as moment from "moment";
import { misionesCollection, usersCollection } from "@/firebase";
import Vue from "vue";

import { ServerTable, ClientTable, Event } from "vue-tables-2";
Vue.use(ClientTable);

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

import { GChart } from "vue-google-charts";

export default {
  components: {
    SidebarAdmin,
    HeaderAdmin,
    Glyphicons,
    GChart,
  },
  data() {
    return {
      file: null,
      csv: null,
      loaded: false,
      filtros: {
        grupo: "",
        genero: "",
      },
      filtros2: {
        grupo: "",
        genero: "",
      },
      filtros3: {
        fortaleza: "",
        perfil: "",
      },
      filtros4: {
        fortaleza: "",
        perfil: "",
      },
      filtros5: {
        fortaleza: "",
        perfil: "",
      },
      chartData: [],
      chartData2_2: [
        ["Procedimental", "Empático", "Analítico", "Creativo"],
        ["Procedimental", 0, 0, 0],
        ["Empático", 0, 0, 0],
        ["Analítico", 0, 0, 0],
        ["Creativo", 0, 0, 0],
      ],
      chartData2_1: [
        ["Procedimental", "Empático", "Analítico", "Creativo"],
        ["Procedimental", 0, 0, 0],
        ["Empático", 0, 0, 0],
        ["Analítico", 0, 0, 0],
        ["Creativo", 0, 0, 0],
      ],
      chartData2: [
        ["Procedimental", "Empático", "Analítico", "Creativo"],
        ["Procedimental", 0, 0, 0],
        ["Empático", 0, 0, 0],
        ["Analítico", 0, 0, 0],
        ["Creativo", 0, 0, 0],
      ],
      chartData3: [["Procedimental", "Empático", "Analítico", "Creativo"]],
      chartData3_1: [["Procedimental", "Empático", "Analítico", "Creativo"]],
      chartData4: [["Procedimental", "Empático", "Analítico", "Creativo"]],
      chartData4_1: [["Procedimental", "Empático", "Analítico", "Creativo"]],
      chartData5: [["Procedimental", "Empático", "Analítico", "Creativo"]],
      chartData5_1: [["Procedimental", "Empático", "Analítico", "Creativo"]],

      chartDataVias: [["Procedimental", "Empático", "Analítico", "Creativo"]],
      chartDataVias_1: [["Procedimental", "Empático", "Analítico", "Creativo"]],


      chartData4_2: [],
      chartOptions: {
        is3D: true,
        title: "Fortaleza vs. Campos del Conocimiento",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
        colors: ["#954be7", "#e98cb5", "#1545ae", "#4ccbad"],
      },
      chartOptions1_2: {
        is3D: true,
        title: "Competencias vs. Campos del Conocimiento",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
        //colors: ["#954be7", "#e98cb5", "#1545ae", "#4ccbad"],
      },
      chartOptions2_2: {
        is3D: true,
        title: "Perfil de competencias",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
        //colors: ["#06c54a", "#fe4700", "#33ccfd", "#e354ae"],
      },
      chartOptions2_1: {
        is3D: true,
        title: "Fortaleza",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
        colors: ["#06c54a", "#fe4700", "#33ccfd", "#e354ae"],
      },
      chartOptions2: {
        is3D: true,
        title: "Competencias",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
        colors: ["#06c54a", "#fe4700", "#33ccfd", "#e354ae"],
      },
      chartOptions3: {
        is3D: true,
        title: "Campos del conocimiento",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
        //colors: [ "#8a00ff", "#0024ff", "#00e4ff", "#00ffa8", "#06ff00", "#d2ff00", "#ffd200", "#ff2a00", "#ff00a8", "#d800ff"],
      },
      chartOptions3_1: {
        is3D: true,
        title: "Campos especificos",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
        //colors: [ "#8a00ff", "#0024ff", "#00e4ff", "#00ffa8", "#06ff00", "#d2ff00", "#ffd200", "#ff2a00", "#ff00a8", "#d800ff"],
      },
      chartOptions4: {
        is3D: true,
        title: "Objetivo de Desarrollo",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
        //colors: ["#f38130", "#340b97", "#1545ae", "#e98cb5", "#206433"],
      },
      chartOptions4_1: {
        is3D: true,
        title: "Objetivo de Desarrollo",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
        //colors: ["#f38130", "#340b97", "#1545ae", "#e98cb5", "#206433"],
      },
      chartOptions5: {
        is3D: true,
        title: "Top de Carreras",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
        //colors: ["#f38130", "#340b97", "#1545ae", "#e98cb5", "#206433"],
      },
      chartOptions5_1: {
        is3D: true,
        title: "Top de Carreras",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
        //colors: ["#f38130", "#340b97", "#1545ae", "#e98cb5", "#206433"],
      },
      chartOptionsVias: {
        is3D: true,
        title: "Top de Carreras",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
        //colors: ["#f38130", "#340b97", "#1545ae", "#e98cb5", "#206433"],
      },
      chartOptionsVias_1: {
        is3D: true,
        title: "Top de Carreras",
        subtitle: "Sales, Expenses, and Profit: 2014-2017",
        //colors: ["#f38130", "#340b97", "#1545ae", "#e98cb5", "#206433"],
      },
      formDisponibles: {
        disponibles: 100,
      },
      form: {
        id_usuario: "",
        nombre: "",
        apellidos: "",
        email: "",
        plantel: "",
        grupo: "",
      },
      formCargar: {
        file: "",
      },
      formFacturacion: {
        rfc: "",
        nombre: "",
        email: "",
        telefono: "",
        direccion: "",
      },
      columns: ["nombre", "apellidos", "email", "plantel", "grupo"],
      data: null,
      options: {
        perPage: 100,
        headings: {
          id_usuario: "ID Usuario",
          nombre: "Nombre",
          apellidos: "Apellidos",
          email: "Email",
          plantel: "Plantel",
          grupo: "Grupo",
        },
        editableColumns: [],
        sortable: [],
        texts: {
          count:
            "Mostrando {from} hasta {to} de {count} registros|{count} registros|Un registro",
          first: "Primero",
          last: "Último",
          filter: "Filtro:",
          filterPlaceholder: "Búsqueda",
          limit: "Registros:",
          page: "Página:",
          noResults: "No hay datos.",
          noRequest: "Por favor selecciona una opción para filtrar resultados",
          filterBy: "Filtrar por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas",
        },
      },
      grupos: {},
      planteles: [],
      estudiantes: [],
      datacollection: null,
      misiones: [],
      misiones_calculadas_1: 0,
      misiones_calculadas_2: 0,
      misiones_calculadas_3: 0,
      misiones_calculadas_4: 0,
      misiones_calculadas_5: 0,
      misiones_calculadas_5_1: 0,
      camposArre: [],
      objetivosDesarrolloArre: [],
      objetivoDesarrollo: "",
      camposEspecificosArre: [],
      campos_conocimiento_ids: {},
      camposObj: null,
      campos_especificos: null,
      campos_especificos_seleccionados: {},
      bases: null,
      basesArre: [],
      bases_seleccionadas: {},
      carreras_seleccionadas: {},
      initiated: false,
      perfil_de_competencias: [],
      estilos_de_pensamiento: [],
      institucion_id: ""
    };
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  watch: {
    
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
    institucionID(value) {
      if (value) this.init();
    },
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });
    this.init();
  },
  methods: {
    init() {
      //
      console.log('iniciando');

      if((this.userProfile == null || this.institucionID == null) || this.initiated == true ){
        return
      }
      this.institucion_id = this.institucionID;

      if(this.userProfile.user_id == "rcThpvogSRce5y5FkTWAmNjnjYv1"){
        this.institucion_id = this.userProfile.institucion; 
      }

      this.initiated = true;

      this.camposObj = this.$store.state.campos_conocimiento;
      this.campos_conocimiento_ids = this.$store.state.campos_conocimiento_ids;
      this.campos_especificos = this.$store.state.campos_especificos;
      this.planteles = this.$store.state.admin.planteles;
      this.estudiantes = this.$store.state.admin.estudiantes;
      this.bases = this.$store.state.bases;
      console.log({ camposObj: this.camposObj });

      this.perfil_de_competencias = this.$store.state.perfil_de_competencias;
      this.estilos_de_pensamiento = this.$store.state.estilo_de_pensamiento;

      this.objetivosDesarrolloArre = ["PERSONAS","PROSPERIDAD","PLANETA","PAZ","ALIANZAS"];

      this.getMisionesEstudiantes();
    },
    async getMisionesEstudiantes() {
      this.$store.dispatch("showLoader", true);
      //console.log("getting misiones");

      
      let docs;
      if (this.userProfile != null && this.userProfile.user_level == 5) {
        docs = await misionesCollection
          .where("membresia.institucion_id", "==", this.institucion_id)
          .where("user.membresia.grupo", "==", this.userProfile.grupo)
          .get();
      } else {
        docs = await misionesCollection
          .where("membresia.institucion_id", "==", this.institucion_id)
          .get();
      }

      //console.log({ misiones: docs });

      this.misiones = [];
      docs.forEach((doc) => {
        let mision = doc.data();

        mision.id = doc.id;

        //console.log(mision.created_on)
        mision.fecha_registro = this.getFechaFormato(mision.created_on.seconds);

        //console.log({ misiones: mision });

        this.misiones.push(mision);
      });

      this.misiones = this.misiones.sort(this.custom_sort);
      console.log({ misiones_estadisticas: this.misiones });

      this.initNivel1();
      this.calculaNivel23();

      this.calculaNivel232();

      //this.calculaNivel2();
      
      //this.calculaNivel3();
      this.calculaNivel4();
      this.calculaNivel41();


      this.calculaNivel5();
      this.calculaNivel51();

    

      this.$store.dispatch("showLoader", false);
    },
    initNivel1() {
      this.misiones.forEach((mision) => {
        if (mision.membresia.grupo != undefined)
          this.grupos[mision.membresia.grupo] = true;
      });

      //this.grupos = Object.keys(this.grupos).sort();
      let not_sorted = this.grupos;
      let sorted = Object.keys(not_sorted)
        .sort()
        .reduce(function (acc, key) {
          acc[key] = not_sorted[key];
          return acc;
        }, {});

      console.log(sorted);
      this.grupos = sorted;
      console.log({ grupos: this.grupos });
    },
    calculaNivel23() {
      

      let habilidad_0 = 0;
      let habilidad_1 = 0;
      let habilidad_2 = 0;
      let habilidad_3 = 0;

      let campos = {};

      this.camposArre = [];
      this.camposEspecificosArre = [];

      this.misiones_calculadas_3 = [];

      this.chartData3 = [];
  

      this.campos_especificos_seleccionados = {};

      //PARA CADA MISION
      this.misiones.forEach((mision) => {
        
        //REVISAR FILTRO FORTALEZA
      
        if (this.filtros3.fortaleza != "") {
          if (mision.mision2 != undefined && mision.mision2 != null && mision.mision2.fortaleza != undefined && mision.mision2.fortaleza != null) {
            if (this.filtros3.fortaleza !== mision.mision2.fortaleza) {
              return;
            }
          }else{
            //salir de forEach
            return;
          }
        }

        

        //REVISAR SI LA MISION NO VIENE VACIA PARA EL USUARIO
        if (mision.mision3 != undefined && mision.mision3 != null) {

          //REVISAR SI HAY CAMPOS APTOS DEFINIDOS PARA EL USUARIO
          if (
            mision.mision3.campos_aptos != undefined &&
            mision.mision3.campos_aptos != null
          ) {

            //REVISAR SI HAY FILTRO POR CAMPO DEL CONOCIMIENTO SELECCIONADO
            //filtrar por campo del conocimiento
            // // // if (
            // // //   this.filtros3.campo_del_conocimiento != "" &&
            // // //   !this.inCampos(
            // // //     mision.mision3.campos_aptos,
            // // //     this.filtros3.campo_del_conocimiento
            // // //   )
            // // // ) {
            // // //   //SI EL CAMPO DEL CONOCIMIENTO SELECCIONADO NO EXISTE PARA EL USUARIO FINAL, NO TOMAR EN CUENTA
            // // //   //AQUI ES DONDE DEBO HACER EL AJUSTE
            // // //   //SI DEBE DE TOMAR EN CUENTA LA MISION PARA LA PRIMER GRAFICA
            // // //   //PERO NO PARA LA SEGUNDA
            // // //   return;
            // // // }


            //PARA CADA CAMPO APTO DE LA MISION DEL USUARIO FINAL
            mision.mision3.campos_aptos.forEach((campo) => {
              //console.log({campoindividual: campo.campo})

              //SI ESTA SELECCIONADO EL FILTRO DE CAMPO DEL CONOCIMIENTO
              if (this.filtros3.campo_del_conocimiento != "") {
                //CONTAR LOS CAMPOS APTOS 
                this.conteoCampoEspecifico(
                  mision.mision3.campos_aptos,
                  this.filtros3.campo_del_conocimiento
                );
              }


              //HACE EL CONTEO PARA LA PRIMER TABLA
              if (
                campos[this.camposObj["obj" + campo.campo].nombre] == undefined
              ) {
                campos[this.camposObj["obj" + campo.campo].nombre] = 1;
              } else {
                campos[this.camposObj["obj" + campo.campo].nombre] =
                  campos[this.camposObj["obj" + campo.campo].nombre] + 1;
              }
            });

            // fortalezas[mision.mision2.fortaleza] = fortalezas[mision.mision2.fortaleza] + 1;
            // habilidad_0 += mision.mision3.habilidades.habilidad_0;
            // habilidad_1 += mision.mision3.habilidades.habilidad_1;
            // habilidad_2 += mision.mision3.habilidades.habilidad_2;
            // habilidad_3 += mision.mision3.habilidades.habilidad_3;
          }

          //ARRAY QUE GUARDA LAS MISIONES Y DE AHÍ SE SACA EL TAMAÑO DEL ARRAY
          this.misiones_calculadas_3.push(mision);
        }
      });

      console.log({ camposnivel3: campos });

      console.log({
        campos_especificos_seleccionados: this.campos_especificos_seleccionados,
      });

      console.log({ misiones_calculadas_3: this.misiones_calculadas_3 });

      for (var i = 1; i <= this.objectSize(this.camposObj); i++) {
        //console.log({ nombrecampo: this.camposObj["obj" + i].nombre });
        this.camposArre.push(this.camposObj["obj" + i].nombre);
      }
      console.log({camposArre: this.camposArre});

      this.chartData3.push(this.camposArre);

      Object.keys(campos).forEach((campo) => {
        let obj = [campo, campos[campo]];
        for (var i = 0; i < this.camposArre.length - 2; i++) {
          obj.push(0);
        }
        this.chartData3.push(obj);
      });

      console.log({ chartData3: this.chartData3 });

      

    },
    calculaNivel232() {
      
      let habilidad_0 = 0;
      let habilidad_1 = 0;
      let habilidad_2 = 0;
      let habilidad_3 = 0;

      let campos = {};

      this.camposArre = [];
      this.camposEspecificosArre = [];

      this.misiones_calculadas_3 = [];

    
      this.chartData3_1 = [];

      this.campos_especificos_seleccionados = {};

      //PARA CADA MISION
      this.misiones.forEach((mision) => {
        
        //REVISAR FILTRO PERFIL DE COMPETENCIAS
      
        if (this.filtros3.perfil != "") {
          if (mision.mision2 != undefined && mision.mision2 != null && mision.mision2.competencias != undefined && mision.mision2.competencias != null) {
            
            let habilidades_necesarias = this.perfil_de_competencias[this.filtros3.perfil - 1].habilidades_necesarias;

            let perfil_de_competencias_usuario = mision.mision2.competencias;
            

            if (
              habilidades_necesarias.length ==
              this.objectSize(perfil_de_competencias_usuario)
            ) {
              //continuar busqueda
              let concordancia = true;
              for (var i = 0; i < 4; i++) {
                //console.log({ habilidad: perfil_de_competencias_usuario[i] });
                if (perfil_de_competencias_usuario[i] != null) {
                  if (
                    !habilidades_necesarias.includes(
                      perfil_de_competencias_usuario[i][0]
                    )
                  ) {
                    concordancia = false;
                  }
                }
              }

              if (concordancia === false) {
                return;
              }

            }

              
          }else{
            //salir de forEach
            return;
          }

        }

        //REVISAR SI LA MISION NO VIENE VACIA PARA EL USUARIO
        if (mision.mision3 != undefined && mision.mision3 != null) {

          //REVISAR SI HAY CAMPOS APTOS DEFINIDOS PARA EL USUARIO
          if (
            mision.mision3.campos_aptos != undefined &&
            mision.mision3.campos_aptos != null
          ) {

            //REVISAR SI HAY FILTRO POR CAMPO DEL CONOCIMIENTO SELECCIONADO
            //filtrar por campo del conocimiento
            // // // if (
            // // //   this.filtros3.campo_del_conocimiento != "" &&
            // // //   !this.inCampos(
            // // //     mision.mision3.campos_aptos,
            // // //     this.filtros3.campo_del_conocimiento
            // // //   )
            // // // ) {
            // // //   //SI EL CAMPO DEL CONOCIMIENTO SELECCIONADO NO EXISTE PARA EL USUARIO FINAL, NO TOMAR EN CUENTA
            // // //   //AQUI ES DONDE DEBO HACER EL AJUSTE
            // // //   //SI DEBE DE TOMAR EN CUENTA LA MISION PARA LA PRIMER GRAFICA
            // // //   //PERO NO PARA LA SEGUNDA
            // // //   return;
            // // // }


            //PARA CADA CAMPO APTO DE LA MISION DEL USUARIO FINAL
            mision.mision3.campos_aptos.forEach((campo) => {
              //console.log({campoindividual: campo.campo})

              //SI ESTA SELECCIONADO EL FILTRO DE CAMPO DEL CONOCIMIENTO
              if (this.filtros3.campo_del_conocimiento != "") {
                //CONTAR LOS CAMPOS APTOS 
                this.conteoCampoEspecifico(
                  mision.mision3.campos_aptos,
                  this.filtros3.campo_del_conocimiento
                );
              }


              //HACE EL CONTEO PARA LA PRIMER TABLA
              if (
                campos[this.camposObj["obj" + campo.campo].nombre] == undefined
              ) {
                campos[this.camposObj["obj" + campo.campo].nombre] = 1;
              } else {
                campos[this.camposObj["obj" + campo.campo].nombre] =
                  campos[this.camposObj["obj" + campo.campo].nombre] + 1;
              }
            });

            // fortalezas[mision.mision2.fortaleza] = fortalezas[mision.mision2.fortaleza] + 1;
            // habilidad_0 += mision.mision3.habilidades.habilidad_0;
            // habilidad_1 += mision.mision3.habilidades.habilidad_1;
            // habilidad_2 += mision.mision3.habilidades.habilidad_2;
            // habilidad_3 += mision.mision3.habilidades.habilidad_3;
          }

          //ARRAY QUE GUARDA LAS MISIONES Y DE AHÍ SE SACA EL TAMAÑO DEL ARRAY
          this.misiones_calculadas_3.push(mision);
        }
      });

      console.log({ camposnivel3: campos });

      console.log({
        campos_especificos_seleccionados: this.campos_especificos_seleccionados,
      });

      console.log({ misiones_calculadas_3: this.misiones_calculadas_3 });

      for (var i = 1; i <= this.objectSize(this.camposObj); i++) {
        //console.log({ nombrecampo: this.camposObj["obj" + i].nombre });
        this.camposArre.push(this.camposObj["obj" + i].nombre);
      }
      console.log({camposArre: this.camposArre});

      this.chartData3_1.push(this.camposArre);

      Object.keys(campos).forEach((campo) => {
        let obj = [campo, campos[campo]];
        for (var i = 0; i < this.camposArre.length - 2; i++) {
          obj.push(0);
        }
        this.chartData3_1.push(obj);
      });

      console.log({ chartData3_1: this.chartData3_1 });

      

    },
    calculaNivel2() {

      let habilidad_0 = 0;
      let habilidad_1 = 0;
      let habilidad_2 = 0;
      let habilidad_3 = 0;

      let fortalezas = {
        habilidad_0: 0,
        habilidad_1: 0,
        habilidad_2: 0,
        habilidad_3: 0,
      };
      let perfiles = {
            "Analítico - Procedimental" : 0,
            "Analítico - Empático" : 0,
            "Analítico - Creativo" : 0,
            "Creativo - Procedimental" : 0,
            "Creativo - Empático" : 0,
            "Empático - Procedimental" : 0,
            "Analítico - Creativo - Procedimental" : 0,
            "Analítico - Creativo - Empático" : 0,
            "Procedimental - Empático - Analítico" : 0,
            "Procedimental - Empático - Creativo" : 0,
            "Analítico - Creativo - Procedimental - Empático" : 0,
            "Procedimental" : 0,
            "Analítico" : 0,
            "Creativo" : 0,
            "Empático" : 0
          };

      this.misiones_calculadas_2 = [];

      this.misiones.forEach((mision) => {
        //filtrar por grupo
        if (this.filtros2.grupo != "") {
          if (this.filtros2.grupo !== mision.membresia.grupo) {
            return;
          }
        }

        //filtrar por genero
        if (this.filtros2.genero != "") {
          if (this.filtros2.genero !== mision.user.genero) {
            return;
          }
        }

        if (mision.mision2 != undefined && mision.mision2 != null) {
          fortalezas[mision.mision2.fortaleza] =
            fortalezas[mision.mision2.fortaleza] + 1;

          habilidad_0 += mision.mision2.habilidades.habilidad_0;
          habilidad_1 += mision.mision2.habilidades.habilidad_1;
          habilidad_2 += mision.mision2.habilidades.habilidad_2;
          habilidad_3 += mision.mision2.habilidades.habilidad_3;

          this.misiones_calculadas_2.push(mision);

          //calculo de perfil de competencias 2021
          let perfil_de_competencias_usuario = {};
          perfil_de_competencias_usuario = mision.mision2.competencias;

          this.perfil_de_competencias.forEach((perfil) => {
              // console.log({ perfil: perfil });
              // console.log({
              //   usuarilength: this.objectSize(this.perfil_de_competencias_usuario)
              // });
              if (
                perfil.habilidades_necesarias.length ==
                this.objectSize(perfil_de_competencias_usuario)
              ) {
                //continuar busqueda
                let concordancia = true;
                for (var i = 0; i < 4; i++) {
                  //console.log({ habilidad: perfil_de_competencias_usuario[i] });
                  if (perfil_de_competencias_usuario[i] != null) {
                    if (
                      !perfil.habilidades_necesarias.includes(
                        perfil_de_competencias_usuario[i][0]
                      )
                    ) {
                      concordancia = false;
                    }
                  }
                }

                if (concordancia === true) {
                  perfiles[perfil.nombre] = perfiles[perfil.nombre] + 1;
                }
              }
            });


          //fin calculo de perfil de competencias

        }
      });




      console.log({ misiones_calculadas_2: this.misiones_calculadas_2 });

      this.chartData2_1 = [
        ["Procedimental", "Empático", "Analítico", "Creativo"],
        ["Procedimental", fortalezas["habilidad_0"], 0, 0],
        ["Empático", fortalezas["habilidad_1"], 0, 0],
        ["Analítico", fortalezas["habilidad_2"], 0, 0],
        ["Creativo", fortalezas["habilidad_3"], 0, 0],
      ];

      this.chartData2 = [
        ["Procedimental", "Empático", "Analítico", "Creativo"],
        ["Procedimental", habilidad_0, 0, 0],
        ["Empático", habilidad_1, 0, 0],
        ["Analítico", habilidad_2, 0, 0],
        ["Creativo", habilidad_3, 0, 0],
      ];

      this.chartData2_2 = [
        ["Analítico - Procedimental", "Analítico - Empático", "Analítico - Creativo", "Creativo - Procedimental", "Creativo - Empático", "Empático - Procedimental", "Analítico - Creativo - Procedimental", "Analítico - Creativo - Empático", "Procedimental - Empático - Analítico", "Procedimental - Empático - Creativo", "Analítico - Creativo - Procedimental - Empático", "Procedimental", "Analítico", "Creativo", "Empático" ],

        ["Analítico - Procedimental", perfiles["Analítico - Procedimental"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Analítico - Empático", perfiles["Analítico - Empático"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Analítico - Creativo", perfiles["Analítico - Creativo"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Creativo - Procedimental", perfiles["Creativo - Procedimental"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Creativo - Empático", perfiles["Creativo - Empático"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Empático - Procedimental", perfiles["Empático - Procedimental"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Analítico - Creativo - Procedimental", perfiles["Analítico - Creativo - Procedimental"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Analítico - Creativo - Empático", perfiles["Analítico - Creativo - Empático"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Procedimental - Empático - Analítico", perfiles["Procedimental - Empático - Analítico"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Procedimental - Empático - Creativo", perfiles["Procedimental - Empático - Creativo"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Analítico - Creativo - Procedimental - Empático", perfiles["Analítico - Creativo - Procedimental - Empático"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Procedimental", perfiles["Procedimental"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Analítico", perfiles["Analítico"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Creativo", perfiles["Creativo"], 0,0,0,0,0,0,0,0,0,0,0,0,0],
        ["Empático", perfiles["Empático"], 0,0,0,0,0,0,0,0,0,0,0,0,0]
        
      ];


    },
    inCampos(campos_aptos, campo_del_conocimiento) {
      let flag = false;

      //console.log({camposids: this.campos_conocimiento_ids})
      campos_aptos.forEach((campo) => {
        // console.log(this.campos_conocimiento_ids[campo_del_conocimiento])
        // console.log({campo: campo.campo})
        if (
          campo.campo ==
          this.campos_conocimiento_ids["" + campo_del_conocimiento]
        ) {
          flag = true;
        }
      });
      //console.log({flag})
      return flag;
    },
    conteoCampoEspecifico(campos_aptos, campo_del_conocimiento) {
      let flag = false;

      //PARA CADA CAMPO APTO DEL USUARIO
      //console.log({camposids: this.campos_conocimiento_ids})
      campos_aptos.forEach((campo) => {
        // console.log(this.campos_conocimiento_ids[campo_del_conocimiento])
        // console.log({campo: campo.campo})

        //SI EL CAMPO CAMPO ES IGUAL AL ID, FLAG = TRUE
        if (
          campo.campo ==
          this.campos_conocimiento_ids["" + campo_del_conocimiento]
        ) {
          flag = true;

          //console.log({campoespecifico: campo.campo_especifico})
          //console.log({camposespecificosseleccionados: this.campos_especificos_seleccionados[this.campos_especificos["obj" + campo.campo_especifico].nombre]})


          //HACE EL CONTEO DEL CAMPO ESPECIFICO PARA LA SEGUNDA TABLA
          if (
            this.campos_especificos_seleccionados[
              this.campos_especificos["obj" + campo.campo_especifico].nombre
            ] == undefined
          ) {
            this.campos_especificos_seleccionados[
              this.campos_especificos["obj" + campo.campo_especifico].nombre
            ] = 1;
          } else {
            this.campos_especificos_seleccionados[
              this.campos_especificos["obj" + campo.campo_especifico].nombre
            ] =
              this.campos_especificos_seleccionados[
                this.campos_especificos["obj" + campo.campo_especifico].nombre
              ] + 1;
          }
        }
      });

      //console.log({flag})
      return flag;
    },
    objectSize(obj) {
      var size = 0,
        key;
      for (key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) size++;
      }
      return size;
    },
    calculaNivel3() {
      let habilidad_0 = 0;
      let habilidad_1 = 0;
      let habilidad_2 = 0;
      let habilidad_3 = 0;

      let campos = {};

      this.camposArre = [];
      this.camposEspecificosArre = [];

      this.misiones_calculadas_3 = [];

      this.chartData3 = [];
      this.chartData3_1 = [];

      this.campos_especificos_seleccionados = {};

      //PARA CADA MISION
      this.misiones.forEach((mision) => {
        
        //REVISAR FILTRO GRUPO
        //filtrar por grupo
        if (this.filtros3.grupo != "") {
          if (this.filtros3.grupo !== mision.membresia.grupo) {
            return;
          }
        }

        //REVISAR FILTRO DE GENERO
        //filtrar por genero
        if (this.filtros3.genero != "") {
          if (this.filtros3.genero !== mision.user.genero) {
            return;
          }
        }

        //REVISAR SI LA MISION NO VIENE VACIA PARA EL USUARIO
        if (mision.mision3 != undefined && mision.mision3 != null) {

          //REVISAR SI HAY CAMPOS APTOS DEFINIDOS PARA EL USUARIO
          if (
            mision.mision3.campos_aptos != undefined &&
            mision.mision3.campos_aptos != null
          ) {

            //REVISAR SI HAY FILTRO POR CAMPO DEL CONOCIMIENTO SELECCIONADO
            //filtrar por campo del conocimiento
            // // // if (
            // // //   this.filtros3.campo_del_conocimiento != "" &&
            // // //   !this.inCampos(
            // // //     mision.mision3.campos_aptos,
            // // //     this.filtros3.campo_del_conocimiento
            // // //   )
            // // // ) {
            // // //   //SI EL CAMPO DEL CONOCIMIENTO SELECCIONADO NO EXISTE PARA EL USUARIO FINAL, NO TOMAR EN CUENTA
            // // //   //AQUI ES DONDE DEBO HACER EL AJUSTE
            // // //   //SI DEBE DE TOMAR EN CUENTA LA MISION PARA LA PRIMER GRAFICA
            // // //   //PERO NO PARA LA SEGUNDA
            // // //   return;
            // // // }


            //PARA CADA CAMPO APTO DE LA MISION DEL USUARIO FINAL
            mision.mision3.campos_aptos.forEach((campo) => {
              //console.log({campoindividual: campo.campo})

              //SI ESTA SELECCIONADO EL FILTRO DE CAMPO DEL CONOCIMIENTO
              if (this.filtros3.campo_del_conocimiento != "") {
                //CONTAR LOS CAMPOS APTOS 
                this.conteoCampoEspecifico(
                  mision.mision3.campos_aptos,
                  this.filtros3.campo_del_conocimiento
                );
              }


              //HACE EL CONTEO PARA LA PRIMER TABLA
              if (
                campos[this.camposObj["obj" + campo.campo].nombre] == undefined
              ) {
                campos[this.camposObj["obj" + campo.campo].nombre] = 1;
              } else {
                campos[this.camposObj["obj" + campo.campo].nombre] =
                  campos[this.camposObj["obj" + campo.campo].nombre] + 1;
              }
            });

            // fortalezas[mision.mision2.fortaleza] = fortalezas[mision.mision2.fortaleza] + 1;
            // habilidad_0 += mision.mision3.habilidades.habilidad_0;
            // habilidad_1 += mision.mision3.habilidades.habilidad_1;
            // habilidad_2 += mision.mision3.habilidades.habilidad_2;
            // habilidad_3 += mision.mision3.habilidades.habilidad_3;
          }

          //ARRAY QUE GUARDA LAS MISIONES Y DE AHÍ SE SACA EL TAMAÑO DEL ARRAY
          this.misiones_calculadas_3.push(mision);
        }
      });

      console.log({ camposnivel3: campos });

      console.log({
        campos_especificos_seleccionados: this.campos_especificos_seleccionados,
      });

      console.log({ misiones_calculadas_3: this.misiones_calculadas_3 });

      for (var i = 1; i <= this.objectSize(this.camposObj); i++) {
        //console.log({ nombrecampo: this.camposObj["obj" + i].nombre });
        this.camposArre.push(this.camposObj["obj" + i].nombre);
      }
      console.log({camposArre: this.camposArre});

      this.chartData3.push(this.camposArre);

      Object.keys(campos).forEach((campo) => {
        let obj = [campo, campos[campo]];
        for (var i = 0; i < this.camposArre.length - 2; i++) {
          obj.push(0);
        }
        this.chartData3.push(obj);
      });

      console.log({ chartData3: this.chartData3 });

      //llenar segunda grafica nivel 3

      if (this.filtros3.campo_del_conocimiento != "") {
        console.log({
          lencampos: this.camposObj[
            "obj" +
              this.campos_conocimiento_ids[this.filtros3.campo_del_conocimiento]
          ].campos_especificos,
        });

        //carga los campos especificos desde el objeto en store
        if (this.objectSize(this.campos_especificos_seleccionados) > 0) {
          for (
            i = 0;
            i <
            this.camposObj[
              "obj" +
                this.campos_conocimiento_ids[
                  this.filtros3.campo_del_conocimiento
                ]
            ].campos_especificos.length;
            i++
          ) {
            //console.log({ nombrecampo: this.camposObj["obj" + i].nombre });
            this.camposEspecificosArre.push(
              this.camposObj[
                "obj" +
                  this.campos_conocimiento_ids[
                    this.filtros3.campo_del_conocimiento
                  ]
              ].campos_especificos[i].nombre
            );
          }
        }

        //inicializa el primer item del chart
        if (this.camposEspecificosArre.length == 1) {
          this.camposEspecificosArre.push("");
        }
        this.chartData3_1.push(this.camposEspecificosArre);

        console.log({
          tecnologia: Object.keys(this.campos_especificos_seleccionados),
        });

        Object.keys(this.campos_especificos_seleccionados).forEach((campo) => {
          // console.log({campoarre: campo})
          // console.log({campsespe: this.campos_especificos_seleccionados[''+campo]})
          //pone en el primer lugar el valor de la suma contabilizada para el campo específico
          let obj = [campo, this.campos_especificos_seleccionados["" + campo]];
          for (i = 0; i < this.camposEspecificosArre.length - 2; i++) {
            obj.push(0);
          }
          this.chartData3_1.push(obj);
        });

        console.log({ chartData3_1: this.chartData3_1 });
      }

      // // this.chartData2 = [
      // //   ["Procedimental", "Empático", "Analítico", "Creativo"],
      // //   ["Procedimental", habilidad_0, 0, 0],
      // //   ["Empático", habilidad_1, 0, 0],
      // //   ["Analítico", habilidad_2, 0, 0],
      // //   ["Creativo", habilidad_3, 0, 0],
      // // ];
    },
    calculaNivel4() {
      
      this.camposEspecificosArre = [];

      this.misiones_calculadas_4 = [];

      this.chartData4 = [];

      this.bases_seleccionadas = this.getBasesObj();

      console.log({bases_seleccionadas_n4: this.bases_seleccionadas})

      this.misiones.forEach((mision) => {
        
        //filtrar por fortaleza
        if (this.filtros4.fortaleza != "") {
          if (mision.mision2 != undefined && mision.mision2 != null && mision.mision2.fortaleza != undefined && mision.mision2.fortaleza != null) {
            if (this.filtros4.fortaleza !== mision.mision2.fortaleza) {
              return;
            }
          }else{
            //salir de forEach
            return;
          }
        }



        if (
          mision.mision4 != undefined &&
          mision.mision4 != null &&
          mision.mision4.base_seleccionada != undefined
        ) {
          if (
            this.bases_seleccionadas[
              this.bases["base_" + mision.mision4.base_seleccionada].nombre
            ] == undefined
          ) {
            this.bases_seleccionadas[
              this.bases["base_" + mision.mision4.base_seleccionada].nombre
            ] = 1;
          } else {
            this.bases_seleccionadas[
              this.bases["base_" + mision.mision4.base_seleccionada].nombre
            ] =
              this.bases_seleccionadas[
                this.bases["base_" + mision.mision4.base_seleccionada].nombre
              ] + 1;
          }

          this.misiones_calculadas_4.push(mision);
        }
      });

      console.log({ bases_seleccionadas: this.bases_seleccionadas });

      console.log({ misiones_calculadas_4: this.misiones_calculadas_4 });

      this.chartData4.push(this.basesArre);

      console.log({
        tecnologia: Object.keys(this.campos_especificos_seleccionados),
      });

      Object.keys(this.bases).forEach((key) => {
        let obj = [
          this.bases[key].nombre,
          this.bases_seleccionadas[this.bases[key].nombre],
        ];
        for (var i = 0; i < this.basesArre.length - 2; i++) {
          obj.push(0);
        }
        this.chartData4.push(obj);
      });

      console.log({ chart4: this.chartData4 });

    },
    calculaNivel41() {
      
      this.camposEspecificosArre = [];

      this.misiones_calculadas_4 = [];

      this.chartData4_1 = [];

      this.bases_seleccionadas = this.getBasesObj();

      console.log({bases_seleccionadas_n4: this.bases_seleccionadas})

      this.misiones.forEach((mision) => {
        

        //REVISAR FILTRO PERFIL DE COMPETENCIAS
      
        if (this.filtros4.perfil != "") {
          if (mision.mision2 != undefined && mision.mision2 != null && mision.mision2.competencias != undefined && mision.mision2.competencias != null) {
            
            let habilidades_necesarias = this.perfil_de_competencias[this.filtros4.perfil - 1].habilidades_necesarias;

            let perfil_de_competencias_usuario = mision.mision2.competencias;
            

            if (
              habilidades_necesarias.length ==
              this.objectSize(perfil_de_competencias_usuario)
            ) {
              //continuar busqueda
              let concordancia = true;
              for (var i = 0; i < 4; i++) {
                //console.log({ habilidad: perfil_de_competencias_usuario[i] });
                if (perfil_de_competencias_usuario[i] != null) {
                  if (
                    !habilidades_necesarias.includes(
                      perfil_de_competencias_usuario[i][0]
                    )
                  ) {
                    concordancia = false;
                  }
                }
              }

              if (concordancia === false) {
                return;
              }

            }

              
          }else{
            //salir de forEach
            return;
          }

        }

        if (
          mision.mision4 != undefined &&
          mision.mision4 != null &&
          mision.mision4.base_seleccionada != undefined
        ) {
          if (
            this.bases_seleccionadas[
              this.bases["base_" + mision.mision4.base_seleccionada].nombre
            ] == undefined
          ) {
            this.bases_seleccionadas[
              this.bases["base_" + mision.mision4.base_seleccionada].nombre
            ] = 1;
          } else {
            this.bases_seleccionadas[
              this.bases["base_" + mision.mision4.base_seleccionada].nombre
            ] =
              this.bases_seleccionadas[
                this.bases["base_" + mision.mision4.base_seleccionada].nombre
              ] + 1;
          }

          this.misiones_calculadas_4.push(mision);
        }
      });

      console.log({ bases_seleccionadas: this.bases_seleccionadas });

      console.log({ misiones_calculadas_4: this.misiones_calculadas_4 });

      this.chartData4_1.push(this.basesArre);

      console.log({
        tecnologia: Object.keys(this.campos_especificos_seleccionados),
      });

      Object.keys(this.bases).forEach((key) => {
        let obj = [
          this.bases[key].nombre,
          this.bases_seleccionadas[this.bases[key].nombre],
        ];
        for (var i = 0; i < this.basesArre.length - 2; i++) {
          obj.push(0);
        }
        this.chartData4_1.push(obj);
      });

      console.log({ chart4_1: this.chartData4_1 });

    },
    calculaNivel5() {
      

      this.misiones_calculadas_5 = [];

      this.chartDataVias = [];

      let carreras_seleccionadas = [];

      this.misiones.forEach((mision) => {
        
        //filtrar por fortaleza
        if (this.filtros5.fortaleza != "") {
          if (mision.mision2 != undefined && mision.mision2 != null && mision.mision2.fortaleza != undefined && mision.mision2.fortaleza != null) {
            if (this.filtros5.fortaleza !== mision.mision2.fortaleza) {
              return;
            }
          }else{
            //salir de forEach
            return;
          }
        }



        if (
          mision.vias != undefined &&
          mision.vias != null &&
          mision.vias.length > 0
        ) {

          //extraer vias
          
          // console.log(mision.vias);
          //console.log({longitud: mision.vias.length});

          let vias = [...mision.vias];
          let ultima_eleccion = vias.pop(); 

          let carreras = ultima_eleccion.carreras_seleccionadas;

          // console.log({ultima_eleccion});
          // console.log({carreras});

          for(var i = 0; i < 3; i++){

            //console.log(carreras[i].carrera.nombre);

            if (
              carreras_seleccionadas[carreras[i].carrera.nombre] == undefined
            ) {
              carreras_seleccionadas[carreras[i].carrera.nombre] = 1;
            } else {
              carreras_seleccionadas[carreras[i].carrera.nombre] = carreras_seleccionadas[carreras[i].carrera.nombre] + 1;
            }

          }

          this.misiones_calculadas_5.push(mision);

        }
      });

      
      console.log({ misiones_calculadas_5carreras: this.misiones_calculadas_5 });

      let obj = [];
      Object.keys(carreras_seleccionadas).forEach((key) => {
        
        obj.push(key);
       
      });
       this.chartDataVias.push(obj);

      //console.log({chartDataViascarreras: this.chartDataVias});


      Object.keys(carreras_seleccionadas).forEach((key) => {
        let obj2 = [
          key,
          carreras_seleccionadas[key]
        ];
        for (var j = 0; j < Object.keys(carreras_seleccionadas).length - 2; j++) {
          obj2.push(0);
        }
        this.chartDataVias.push(obj2);
      });

       console.log({ chartDataViascarrerastermino: this.chartDataVias });

    },
    calculaNivel51() {
      


      this.misiones_calculadas_5_1 = [];

      this.chartDataVias_1 = [];

      let carreras_seleccionadas = [];


      this.misiones.forEach((mision) => {
        

        //REVISAR FILTRO PERFIL DE COMPETENCIAS
      
        if (this.filtros5.perfil != "") {
          if (mision.mision2 != undefined && mision.mision2 != null && mision.mision2.competencias != undefined && mision.mision2.competencias != null) {
            
            let habilidades_necesarias = this.perfil_de_competencias[this.filtros5.perfil - 1].habilidades_necesarias;

            let perfil_de_competencias_usuario = mision.mision2.competencias;
            

            if (
              habilidades_necesarias.length ==
              this.objectSize(perfil_de_competencias_usuario)
            ) {
              //continuar busqueda
              let concordancia = true;
              for (var i = 0; i < 4; i++) {
                //console.log({ habilidad: perfil_de_competencias_usuario[i] });
                if (perfil_de_competencias_usuario[i] != null) {
                  if (
                    !habilidades_necesarias.includes(
                      perfil_de_competencias_usuario[i][0]
                    )
                  ) {
                    concordancia = false;
                  }
                }
              }

              if (concordancia === false) {
                return;
              }

            }

              
          }else{
            //salir de forEach
            return;
          }

        }




        if (
          mision.vias != undefined &&
          mision.vias != null &&
          mision.vias.length > 0
        ) {

          //extraer vias
          
          // console.log(mision.vias);
          //console.log({longitud: mision.vias.length});

          let vias = [...mision.vias];
          let ultima_eleccion = vias.pop(); 

          let carreras = ultima_eleccion.carreras_seleccionadas;

          // console.log({ultima_eleccion});
          // console.log({carreras});

          for(i = 0; i < 3; i++){

            //console.log(carreras[i].carrera.nombre);

            if (
              carreras_seleccionadas[carreras[i].carrera.nombre] == undefined
            ) {
              carreras_seleccionadas[carreras[i].carrera.nombre] = 1;
            } else {
              carreras_seleccionadas[carreras[i].carrera.nombre] = carreras_seleccionadas[carreras[i].carrera.nombre] + 1;
            }

          }

          this.misiones_calculadas_5_1.push(mision);

        }
      });

      
      console.log({ misiones_calculadas_5_1carreras: this.misiones_calculadas_5_1 });

      let obj = [];
      Object.keys(carreras_seleccionadas).forEach((key) => {
        
        obj.push(key);
       
      });
       this.chartDataVias_1.push(obj);

      //console.log({chartDataVias_1carreras: this.chartDataVias_1});


      Object.keys(carreras_seleccionadas).forEach((key) => {
        let obj2 = [
          key,
          carreras_seleccionadas[key]
        ];
        for (var j = 0; j < Object.keys(carreras_seleccionadas).length - 2; j++) {
          obj2.push(0);
        }
        this.chartDataVias_1.push(obj2);
      });

       console.log({ chartDataVias_1carrerastermino: this.chartDataVias_1 });

       

    },
    getBasesObj() {
      let obj = {};
      this.basesArre = [];

      Object.keys(this.bases).forEach((key) => {
        //console.log({key: key})

        if (this.bases[key].nombre != undefined) {
          obj[this.bases[key].nombre] = 0;
          this.basesArre.push(this.bases[key].nombre);
        }
      });
      return obj;
    },
    getFechaFormato(time) {
      return moment.unix(time).format("MMM D, Y HH:mm:ss");
    },
    custom_sort_generico(a, b) {
      if (a.key < b.key) {
        return -1;
      }
      if (a.key > b.key) {
        return 1;
      }
      return 0;
    },
    custom_sort(a, b) {
      return new Date(a.created_on.seconds) - new Date(b.created_on.seconds);
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },
    confirmarCarga() {
      this.csv.forEach((estudiante) => {
        this.estudiantes.push(estudiante);
      });
      this.csv = null;
      this.$store.state.admin.estudiantes = this.estudiantes;
    },
    submitCarga() {
      console.log({ csv: this.csv });
    },
    fileSelected: function ($event) {
      console.log($event);

      this.file = $event.target.files[0];

      var reader = new FileReader();

      reader.onload = function (e) {
        // get loaded data and render thumbnail.

        console.log(e.target.result);
      };

      // read the image file as a data URL.
      reader.readAsDataURL(this.file);
    },
    submitForm(e) {
      e.preventDefault();

      this.estudiantes.push(this.form);
      this.$store.state.admin.estudiantes = this.estudiantes;

      //this.$store.dispatch("setDatosAdministrador", this.form);
    },
  },
};
</script>
